<template>
    <BaseAlert :type="Functional.Info">
        {{ $t('globalMessages.maintenance.message') }}

        <template #description>
            <!-- eslint-disable vue/no-v-html -->
            <span
                @click="handleSupportLinkClick"
                v-html="$t('globalMessages.maintenance.description')"
            ></span>
        </template>
        <!-- eslint-enable vue/no-v-html -->
    </BaseAlert>
</template>

<script setup lang="ts">
import { Functional } from '@/types';
import BaseAlert from './BaseAlert.vue';
import { useSupport } from '@/modules/your/composables/support';

const { handleSupportLinkClick } = useSupport();
</script>
